import ScanDetails from '../Common/ScanDetails/scanDetails';
import UnitHelper, { unitTypes } from 'infrastructure/js/utils/uomHelper';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import * as AssetDetailsHelper from '../../../components/AssetPage/OverviewTab/AssetDetails/utils/assetDetailsHelper';
import {getEnumValue, enumTypes} from '../../../utils/enumHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import useLabels from 'infrastructure/js/hooks/useLabels';
import MobileHeader from '../Common/MobileHeader/mobileHeader';
import {useEffect} from 'react';
import ArrowLeftIcon from 'infrastructure/assets/svg/tab-arrow-left.svg';
import FullScreenToggle from 'infrastructure/js/components/FullScreenToggle/fullScreenToggle';

require('./scannedAssetDetails.scss');

export default function ScannedAssetDetails ({asset,
                                              history,
                                             }) {


  const  pageLabels = useLabels('mat.mobile.scannedAssetDetails.');

  useEffect(() => {
    if (!asset) {
      history.push('/MoveAssets');
    }
  }, []);



  const getAlertIcon = (asset, alertType) => {
    return AssetDetailsHelper.getIcon(asset, alertType)
  };

  const renderEtlBond = (exposureTimeLeftBond, currentAsset)=>{
    if (PermissionManager.isEtlBondEnabled()) {
      return ( <div>
        <label>{pageLabels.get('etlBond')}</label>
        <label>{exposureTimeLeftBond} {getAlertIcon(currentAsset, getEnumValue(enumTypes.ALERT_TYPE)('EXPOSURE_TIME_BOND'))}</label>
      </div>)
    }
  }

  const getDetailsItems = (currentAsset) => {

    if (!currentAsset) {
      return [];
    }
    if (  currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('ROLL') ||
          currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL') ||
          currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('CASSETTE') ||
          currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('RESIN')  ) {
        return getRawMaterialDetails(currentAsset)
    }
    else if (currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('KIT')) {
      return getKitDetails(currentAsset)
    }
    else if (currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('TOOL')) {
      return getToolDetails(currentAsset)
    }
    else if (currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('GROUP')) {
      return getGroupDetails(currentAsset)
    }
    return null;
  }

  const getKitDetails = (currentAsset) => {

    let expirationDate = currentAsset.expirationDate ? DateTimeHelper.FormatDateObjectToDayMonth(currentAsset.expirationDate.value) : '';
    let exposureTimeLeftBond = (currentAsset.exposureTimeLeftBond && currentAsset.exposureTimeLeftBond.value !== null) ?
      DateTimeHelper.ConvertMinutesToHoursMinutes(currentAsset.exposureTimeLeftBond.value) : '';
    let exposureTimeLeftCure = (currentAsset.exposureTimeLeftCure && currentAsset.exposureTimeLeftCure.value !== null) ?
      DateTimeHelper.ConvertMinutesToHoursMinutes(currentAsset.exposureTimeLeftCure.value) : '';
   let workOrderDueDate = currentAsset.workOrder?.dueDate ? DateTimeHelper.FormatDateObjectToDayMonth(currentAsset.workOrder.dueDate) : '';

    return (
      [
        {
          label: pageLabels.get('id', '', {assetType: currentAsset.objectType}),
          body: <label>{currentAsset.businessId}</label>
        },
        {
          label: pageLabels.get('type'),
          body: <label>{currentAsset.kitType.businessId}</label>
        },
        {
          bodyOnly: true,
          body: (<div className="section two-columns" key="etl">
            {renderEtlBond(exposureTimeLeftBond, currentAsset)}
            <div>
              <label>{pageLabels.get('etlCure')}</label>
              <label>{exposureTimeLeftCure} {getAlertIcon(currentAsset, getEnumValue(enumTypes.ALERT_TYPE)('EXPOSURE_TIME_CURE'))}</label>
            </div>
          </div>)
        },
        {
          label: pageLabels.get('expiration'),
          body: <label>{expirationDate} {getAlertIcon(currentAsset, getEnumValue(enumTypes.ALERT_TYPE)('EXPIRATION_DATE'))}</label>
        },
        {
          label: pageLabels.get('location'),
          body: <label>{currentAsset.location.name}</label>
        },
        {
          // label: pageLabels.get('length'),
          label: 'WORK ORDER',
          body: <label>{currentAsset.workOrder?.businessId}</label>
        },
        {
          // label: pageLabels.get('width'),
          label: 'Work Order Due Date',
          body: <label>{workOrderDueDate}</label>
        },
        ]
    )
  }

  const getRawMaterialDetails = (currentAsset) => {

    let expirationDate = currentAsset.expirationDate ? DateTimeHelper.FormatDateObjectToDayMonth(currentAsset.expirationDate.value) : '';
    let exposureTimeLeftBond = (currentAsset.exposureTimeLeftBond && currentAsset.exposureTimeLeftBond.value !== null) ?
      DateTimeHelper.ConvertMinutesToHoursMinutes(currentAsset.exposureTimeLeftBond.value) : '';
    let exposureTimeLeftCure = (currentAsset.exposureTimeLeftCure && currentAsset.exposureTimeLeftCure.value !== null) ?
      DateTimeHelper.ConvertMinutesToHoursMinutes(currentAsset.exposureTimeLeftCure.value) : '';
    let materialDetails = currentAsset.material.businessId;

    return (
      [
        {
          label: pageLabels.get('id', '', {assetType: currentAsset.objectType}),
          body: <label>{currentAsset.businessId}</label>
        },
        {
          label: pageLabels.get('type'),
          body: <label>{materialDetails}</label>
        },
        {
          bodyOnly: true,
          body: (<div className="section two-columns" key="etl">
            {renderEtlBond(exposureTimeLeftBond, currentAsset)}
            <div>
              <label>{pageLabels.get('etlCure')}</label>
              <label>{exposureTimeLeftCure} {getAlertIcon(currentAsset, getEnumValue(enumTypes.ALERT_TYPE)('EXPOSURE_TIME_CURE'))}</label>
            </div>
          </div>)
        },
        {
          label: pageLabels.get('expiration'),
          body: <label>{expirationDate} {getAlertIcon(currentAsset, getEnumValue(enumTypes.ALERT_TYPE)('EXPIRATION_DATE'))}</label>
        },
        {
          label: pageLabels.get('location'),
          body: <label>{currentAsset.location.name}</label>
        },

        ...(getUomSection(currentAsset))

      ]
    )
  };

  const getToolDetails = (currentAsset) => {
    return (
      [
        {
          label: pageLabels.get('id', '', {assetType: currentAsset.objectType}),
          body: <label>{currentAsset.businessId || ''}</label>
        },
        {
          label: pageLabels.get('type'),
          body: <label>{currentAsset.toolType?.businessId || ''}</label>
        },
        {
          label: pageLabels.get('location'),
          body: <label>{currentAsset.location?.name || ''}</label>
        },
      ]
    )
  }

  const getGroupDetails = (currentAsset) => {
    return (
      [
        {
          label: pageLabels.get('id', '', {assetType: currentAsset.objectType}),
          body: <label>{currentAsset.businessId || ''}</label>
        },
        {
          label: pageLabels.get('type'),
          body: <label>{currentAsset.groupType?.businessId || ''}</label>
        },
        {
          label: pageLabels.get('location'),
          body: <label>{currentAsset.location?.name || ''}</label>
        },
      ]
    )
  }

  const getUomSection = (currentAsset) => {
    const lengthLeft = currentAsset.lengthLeft ? UnitHelper.serverValueToUserValue(unitTypes.LENGTH, currentAsset.lengthLeft) : 0;
    const m_Length = `${lengthLeft} ${UnitHelper.getLabelForUnitType(unitTypes.LENGTH)}`;
    const width = currentAsset.widthInCentimeter ? UnitHelper.serverValueToUserValue(unitTypes.WIDTH, currentAsset.widthInCentimeter) : 0;
    const m_Width = `${width} ${UnitHelper.getLabelForUnitType(unitTypes.WIDTH)}`;
    const weight = currentAsset.weight ? UnitHelper.serverValueToUserValue(unitTypes.WEIGHT, currentAsset.weight) : 0;
    const m_Weight = `${weight} ${UnitHelper.getLabelForUnitType(unitTypes.WEIGHT)}`;

    if ( (currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('ROLL') && !PermissionManager.isWeightSupported()) ||
          currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('CASSETTE')) {
      return (
        [
          {
            label: pageLabels.get('length'),
            body: <label>{m_Length}</label>
          },
          {
            label: pageLabels.get('width'),
            body: <label>{m_Width}</label>
          },
        ]);
    }
    if (currentAsset.objectType === getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')) {
      return (
        [
          {
            label: pageLabels.get('length'),
            body: <label>{m_Length}</label>
          },
          {
            label: pageLabels.get('weight'),
            body: <label>{m_Weight}</label>
          },
        ]);
    }
    return (
      [
        {
          label: pageLabels.get('weight'),
          body: <label>{m_Weight}</label>
        },
      ]);
  }

  const getHeaderItems = () => {
    return {
      buttons: [
        {
          id: 'leftButton',
          icon: ArrowLeftIcon,
          className: 'divider-right',
          action: () => history.replace('/MoveAssets'),
          // action: () => history?.goBack(),
        },
        {
          id: 'assetDetails',
          label: 'Asset Details',
        },
        {
          id: 'fullScreenButton',
          className: 'divider-left',
          buttonComponent: FullScreenToggle
        },
      ]
    }
  }

  return (
    <div className="scanned-asset-details">
      <MobileHeader {...getHeaderItems()} />
      <ScanDetails details={getDetailsItems(asset)}/>
    </div>
  )
}

ScannedAssetDetails.propTypes = {
};

